import React from "react";
import styles from "../../Styles/Creator_Form/confirm.module.css";

const Confirm = ({
  error,
  values,
  setMenu = (f) => f,
  onSubmit = (f) => f,
}) => {
  return (
    <div className={styles.con}>
      <div className={styles.infotub}>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Full Name:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.name}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Email:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.email}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Phone Number:</span>
          </div>
          <div className={styles.top2}>
            <span>
              +{values.statusCode}
              {values.mobile}
            </span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Location:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.location}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Languages:</span>
          </div>
          <div className={styles.top2}>
            {values.languages.map((language, index) => (
              <span key={index}>
                {language}
                {values.languages.length - 1 === index ? "." : ","}
              </span>
            ))}
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Describe Youself:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.shortdescription}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Profession:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.profession}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Past Experiences:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.pastexperiences}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Presentation knowledge:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.pptknowledge}</span>
          </div>
        </div>
        <div className={styles.info3}>
          <div className={styles.top1}>
            <span>Social Platforms Links:</span>
          </div>
          <div className={styles.top2}>
            <span>{values.social}</span>
          </div>
        </div>
        <div className={styles.button}>
          <div className={styles.but1}>
            <button onClick={() => setMenu("second")}>Previous</button>
          </div>
          {error && <div className={styles.error}>*{error}</div>}
          <div className={styles.but2}>
            <button onClick={() => onSubmit()}>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm;
